import { CommonModule } from '@angular/common';
import { ChangeDetectorRef, ChangeDetectionStrategy, Component, EventEmitter, inject, Input, Output } from '@angular/core';
import { FormsModule, ReactiveFormsModule, UntypedFormControl, UntypedFormGroup } from '@angular/forms';
import { DomSanitizer } from '@angular/platform-browser';
import { ClarityModule } from '@clr/angular';
import dayjs from 'dayjs';
import { ToastService } from 'src/app/services/toast.service';
import { first } from 'rxjs/operators';
import { BackendLocaleDatePipe } from 'src/app/pipes/get-locale-date.pipe';
import { ClrDatagridModule, ClrIcon } from '@clr/angular';
import { HideIDColumnsPipe } from 'src/app/pipes/hide-idcolumns.pipe';
import { MrTranslatePipe } from 'src/app/pipes/mr-translate.pipe';
import { TablePrettyPrintPipe } from 'src/app/pipes/tablePrettyPrint.pipe';
import { APIService } from 'src/app/services/APIService/api.service';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { WorkSheet, utils, writeFile } from 'xlsx';
import { firstValueFrom } from 'rxjs';
import { WebSocketService } from 'src/app/services/Websocket/websocket.service';
import { ConfirmService } from 'src/app/services/confirm.service';

@Component({
  changeDetection: ChangeDetectionStrategy.Eager,
  selector: 'app-gleisgrenzwertverletzung',
  templateUrl: './gleisgrenzwertverletzung.component.html',
  styleUrl: './gleisgrenzwertverletzung.component.scss',
  imports: [
    CommonModule,
    ClarityModule,
    FormsModule,
    ReactiveFormsModule,
    MrTranslatePipe,
    HideIDColumnsPipe,
    TablePrettyPrintPipe,
    BackendLocaleDatePipe,
    ClrDatagridModule,
    ClrIcon,
  ],
  providers: [WebSocketService],
})
export class GleisgrenzwertverletzungComponent {
  private apiService = inject(APIService);
  private toastr = inject(ToastService);
  private mrTranslate = inject(MrTranslatePipe);
  private _sanitizer = inject(DomSanitizer);
  private readonly changeDetectorRef = inject(ChangeDetectorRef);
  protected localeDate = inject(BackendLocaleDatePipe);
  private http = inject(HttpClient);
  private confirmService = inject(ConfirmService);

  private readonly webSocket = inject(WebSocketService);
  API_URL: string;
  spinnertitel: string;
  processprogress: any;
  processstarted: boolean = false;
  uploadprocessrun: boolean = false;
  jwt: string;
  tol: any;

  @Input() modalOpen: boolean = false;
  @Output() onOK: EventEmitter<any> = new EventEmitter<any>();

  isopened: boolean = false;
  inGroup: UntypedFormGroup = new UntypedFormGroup({
    datevon: new UntypedFormControl(BackendLocaleDatePipe.now),
    datebis: new UntypedFormControl(BackendLocaleDatePipe.now),
    srg: new UntypedFormControl(true),
    srl: new UntypedFormControl(false),
    sr1: new UntypedFormControl(false),
    laenge: new UntypedFormControl(5),
    ohneweiche: new UntypedFormControl(0),
  });

  tolrad: UntypedFormGroup = new UntypedFormGroup({
    messart: new UntypedFormControl(''),
    bed: new UntypedFormControl(''),
    bedmin: new UntypedFormControl(''),
    bedmax: new UntypedFormControl(''),
    soll: new UntypedFormControl(''),
    srgp: new UntypedFormControl(''),
    srgm: new UntypedFormControl(''),
    srlp: new UntypedFormControl(''),
    srlm: new UntypedFormControl(''),
    sr1p: new UntypedFormControl(''),
    sr1m: new UntypedFormControl(''),
  });
  verl: UntypedFormGroup = new UntypedFormGroup({
    ih: new UntypedFormControl(''),
    deleteold: new UntypedFormControl(false),
  });

  selTolID: number = 0;
  tolradius: any = [];
  selected: any = [];
  countobjekte: number = 0;
  opruefids: any = [];
  toleranzen: any = [];
  grenzwerte: any = [];
  language: any;
  title: string = 'Grenzwertverletzungen berechnen';
  grenzwerteitems: any = [];

  public get von(): string {
    return this.inGroup.get('datevon').value;
  }

  public set von(value: string) {
    this.inGroup.get('datevon').setValue(value);
    this.getCounts();
  }

  public get bis(): string {
    return this.inGroup.get('datebis').value;
  }

  public set bis(value: string) {
    this.inGroup.get('datebis').setValue(value);
    this.getCounts();
  }

  trackTolItemById(item) {
    return item.ID;
  }

  async getCounts() {
    let valGroup = this.inGroup.value;
    if (!valGroup.datevon || !valGroup.datebis) return;

    const result = await firstValueFrom(
      this.apiService.getMessungAuswertung({
        status: 'getcountgleis',
        start: valGroup.datevon,
        ende: valGroup.datebis,
      })
    );

    if (result) {
      this.countobjekte = result.countobjekte;
      this.opruefids = result.opruefids;
    }
  }

  async onImport() {
    let v = this.verl.value;
    let vals = {
      list: this.grenzwerte.rows,
      old: v.deleteold,
      language: this.language,
    };

    await this.startHubConnection('Verletzungen');
    this.processprogress = '0.0';
    this.uploadprocessrun = true;

    setTimeout(() => {
      this.http
        .post(this.API_URL + '/files/importgrenzwertverletzungen/' + this.webSocket._id(), vals, {
          headers: new HttpHeaders().set('Authorization', 'Bearer ' + this.jwt),
          responseType: 'json',
          reportProgress: true,
          observe: 'events',
        })
        .subscribe((val: any) => {
          if (val.body) {
            if (val.body == 'OK') {
              this.toastr.success(this.mrTranslate.transform('Grenzwertverletzungen wurden erfolgreich importiert'));
              this.grenzwerte.rows = undefined;
              this.uploadprocessrun = false;

              setTimeout(() => {
                this.opruefids = [];
                this.toleranzen = [];
                this.grenzwerte = [];
                this.onOK.emit(false);
              }, 500);
            } else {
              this.toastr.error(val.body);
            }
          }
        });
    }, 250);
    // this.apiService
    //   .ImportGrenzwertverletzungen(s)
    //   .pipe(first())
    //   .subscribe((val: any) => {
    //     if (val == "OK"){
    //       this.toastr.success(this.mrTranslate.transform("Grenzwertverletzungen wurden erfolgreich importiert"));
    //       this.grenzwerte.rows = undefined;

    //     setTimeout(() => {
    //       this.opruefids = [];
    //       this.toleranzen = [];
    //       this.grenzwerte = [];
    //       this.onOK.emit(false);
    //     }, 500);

    //     }
    //   });
  }

  async onExport() {
    await this.startHubConnection('Liste');

    this.uploadprocessrun = true;
    let valGroup = this.inGroup.value;
    let valtolrad = this.tolrad.value;

    let vals = {
      status: 'getgrenzwertliste',
      opruefids: this.opruefids,
      tol: valtolrad,
      option: valGroup,
      language: this.language,
    };

    setTimeout(() => {
      this.http
        .post(this.API_URL + '/files/getgrenzwertliste/' + this.webSocket._id(), vals, {
          headers: new HttpHeaders().set('Authorization', 'Bearer ' + this.jwt),
          responseType: 'json',
          reportProgress: true,
          observe: 'events',
        })
        .subscribe((val: any) => {
          if (val.body) {
            if (val.body.toleranzen) {
              this.title = 'Grenzwertverletzungen einlesen';

              this.tol = val.body.toleranzen;
              this.grenzwerte = val.body.grenzwert;

              if (this.grenzwerte.rows) this.selected = this.grenzwerte.rows[0];
            }
          }
        });
    }, 200);
  }

  saveItemsVerl() {
    let v = this.verl.value;

    if (v.ih == undefined || v.ih == '') {
      this.toastr.error(this.mrTranslate.transform('Bitte Instandsetzung eingeben...!'));
      return;
    }

    const index: number = this.grenzwerte.rows.indexOf(this.selected);
    if (index !== -1) {
      this.grenzwerte.rows[index].Instandsetzung = v.ih;
      this.toastr.success(this.mrTranslate.transform('Einträge wurden gespeichert'));
    }
  }

  onDetailOpenGernzwert(value) {
    this.grenzwerteitems = [];
    if (value != null) {
      let arr1: any[] = ['OSTAMMID', 'OPRUEFID'];

      Object.keys(value).forEach(index => {
        let elem = value[index];
        let v = {
          object: index,
          wert: elem,
        };

        if (!arr1.includes(index)) this.grenzwerteitems.push(v);

        if (index == 'Instandsetzung') {
          this.verl.controls.ih.setValue(elem);
        }
      });
    }
  }

  onDetailOpenMessTol(value) {
    if (value != null) {
      this.selTolID = value.ID;
      this.tolrad.controls.messart.setValue(value.Messart);
      this.tolrad.controls.bed.setValue(value.Bedingung);
      this.tolrad.controls.bedmin.setValue(value['>=']);
      this.tolrad.controls.bedmax.setValue(value['<']);
      this.tolrad.controls.soll.setValue(value['Sollwert']);
      this.tolrad.controls.srgp.setValue(value['SRG+']);
      this.tolrad.controls.srgm.setValue(value['SRG-']);
      this.tolrad.controls.srlp.setValue(value['SRlim +']);
      this.tolrad.controls.srlm.setValue(value['SRlim -']);
      this.tolrad.controls.sr1p.setValue(value['SR100 +']);
      this.tolrad.controls.sr1m.setValue(value['SR100 -']);
    }
  }

  saveItemsMessTol(id: number) {
    let vals = this.tolrad.value;

    if (vals.messart == undefined) {
      this.toastr.error(this.mrTranslate.transform("Bitte 'Messart' auswählen...!"));
      return;
    }

    if (vals.messart == '') {
      this.toastr.error(this.mrTranslate.transform("Bitte 'Messart' auswählen...!"));
      return;
    }

    if (vals.soll == undefined) {
      this.toastr.error(this.mrTranslate.transform('Geben Sie einen Sollwert an...'));
      return;
    }

    if (vals.soll == '') {
      this.toastr.error(this.mrTranslate.transform('Geben Sie einen Sollwert an...'));
      return;
    }

    if (vals.srgp == undefined) {
      this.toastr.error(this.mrTranslate.transform("Bitte 'SRG +' eingeben...!"));
      return;
    }

    if (vals.srgp == '') {
      this.toastr.error(this.mrTranslate.transform("Bitte 'SRG +' eingeben...!"));
      return;
    }

    if (vals.srgm == undefined) {
      this.toastr.error(this.mrTranslate.transform("Bitte 'SRG -' eingeben...!"));
      return;
    }

    if (vals.srgm == '') {
      this.toastr.error(this.mrTranslate.transform("Bitte 'SRG -' eingeben...!"));
      return;
    }

    let saveitems = {
      status: 'updateradiustoleranz',
      id: id,
      messart: vals.messart,
      bed: vals.bed,
      bedmin: vals.bedmin == '' ? null : vals.bedmin,
      bedmax: vals.bedmax == '' ? null : vals.bedmax,
      soll: vals.soll,
      srgp: vals.srgp,
      srgm: vals.srgm,
      srlp: vals.srlp,
      srlm: vals.srlm,
      sr1p: vals.sr1p,
      sr1m: vals.sr1m,
    };

    this.apiService
      .getMessungTol(saveitems)
      .pipe(first())
      .subscribe((val: any) => {
        if (val) {
          this.tolradius = val.radiustoleranzen;
          this.selTolID = 0;
          this.toastr.success(this.mrTranslate.transform('Daten gespeichert'));
        }
      });
  }

  addItemsMessTol() {
    this.selTolID = 0;

    let newrow = {
      ID: 0,
      Messart: this.mrTranslate.transform('Spurweite'),
      Sollwert: 0,
    };
    this.tolradius.rows.push(newrow);
  }

  onExportExcel() {
    const fileName = this.mrTranslate.transform('Grenzwertverletzung') + '.xlsx';
    const wb = utils.book_new();
    const ws: WorkSheet = utils.json_to_sheet(this.tol);
    utils.sheet_add_json(ws, this.grenzwerte.rows, { origin: 'A14' });
    utils.book_append_sheet(wb, ws, this.mrTranslate.transform('Grenzwertverletzung'));
    writeFile(wb, fileName);
  }

  async deleteResetTolVer(item) {
    const ok = await this.confirmService.warning(
      this.mrTranslate.transform('Sind Sie sicher, dass Sie Messwerte korrigieren wollen?')
    );
    if (ok) {
      this.apiService
        .ReSetMessWertFehler(item)
        .pipe(first())
        .subscribe((val: any) => {
          if (val == 'OK') {
            const index: number = this.grenzwerte.rows.indexOf(this.selected);
            if (index !== -1) {
              this.grenzwerte.rows.splice(index, 1);
            }
            this.toastr.success(this.mrTranslate.transform('Messwerte korrigieren'));
            this.selected = this.grenzwerte.rows[0];
          }
        });
    }
  }

  async deleteItemsTolVer(item) {
    const ok = await this.confirmService.danger(
      this.mrTranslate.transform('Sind Sie sicher, dass Sie diesen Eintrag löschen wollen?')
    );
    if (ok) {
      const index: number = this.grenzwerte.rows.indexOf(this.selected);
      if (index !== -1) {
        this.grenzwerte.rows.splice(index, 1);
      }
    }
  }

  async deleteItemsMessTol() {
    const ok = await this.confirmService.danger(
      this.mrTranslate.transform('Sind Sie sicher, dass Sie diesen Eintrag löschen wollen?')
    );
    if (ok) {
      let deleteitems = {
        status: 'deleteradiustoleranz',
        id: this.selTolID,
      };

      this.apiService
        .getMessungTol(deleteitems)
        .pipe(first())
        .subscribe((val: any) => {
          if (val) {
            this.tolradius = val.radiustoleranzen;
            this.selTolID = 0;
            this.toastr.success(this.mrTranslate.transform('Daten gespeichert'));
          }
        });
    }
  }

  open(inData: any) {
    //this.grenzwerte = [];
    this.isopened = true;
    this.inGroup.controls.datevon.setValue(dayjs().startOf('year').format(BackendLocaleDatePipe.format));
    this.inGroup.controls.datebis.setValue(BackendLocaleDatePipe.now);

    this.language = localStorage.getItem('language');

    let vals = {
      status: 'get',
    };

    this.apiService
      .getMessungTol(vals)
      .pipe(first())
      .subscribe((val: any) => {
        this.tolradius = val.radiustoleranzen;

        this.getCounts();
      });

    this.API_URL = this.apiService.getURL();
    this.jwt = localStorage.getItem('jwt');

    this.modalOpen = true;
  }

  connected: boolean;
  async startHubConnection(mode: 'Verletzungen' | 'Liste') {
    this.webSocket._config.name = `Grenzwerte ${mode} Import Progress`;

    await this.webSocket.startCon();
    this.connected = !!this.webSocket.connected;

    this.webSocket.registerHandler('taskStarted', () => (this.processstarted = true));
    this.webSocket.registerHandler('taskProgressChanged', ([procent, info]) =>
      setTimeout(() => {
        this.spinnertitel = info;
        this.processprogress = procent;
      })
    );
    this.webSocket.registerHandler('taskEnded', () =>
      setTimeout(() => {
        this.processprogress = 0;
        this.processstarted = false;
        this.uploadprocessrun = false;
        this.spinnertitel = '';

        this.toastr.success(this.mrTranslate.transform('Grenzwertauswertung ist abgeschlossen'));
        this.opruefids = [];
        this.webSocket.stopCon();
      }, 500)
    );
  }

  close() {
    this.modalOpen = false;
  }

  onSubmit() {
    this.onOK.emit('');
  }
}
